<template>
  <div class="content">
    <TopNavigation :top-act="'8'"/>
    <div>
      <listTopImg :imgType="$store.state.webNavigator=='pc'?'4':'5'"/>
    </div>
    <div >
      <twoLevelList
        :twolist="navLsit"
        @twoType="clickType"/>
    </div>
    <div>
      <aboutPage v-if="type==1"/>
      <suggestions v-if="type==2" @change="clickType" />
      <mySuggestions v-if="type==3" @change="clickType" @suggestionsList="suggestionsList" />
      <suggestionsList v-if="type==4" :phone="phone"/>
    </div>
    <FooterNavigation/>
  </div>
</template>

<script>

import aboutPage from './aboutPage/aboutPage';
import suggestions from './suggestions/suggestions';
import mySuggestions from './mySuggestions/mySuggestions';
import suggestionsList from './suggestionsList/suggestionsList';
import twoLevelList from '../../components/twoLevelList/twoLevelList';
import TopNavigation from '../../components/TopNavigation/TopNavigation';
import FooterNavigation from '../../components/FooterNavigation/FooterNavigation';
import listTopImg from '../../components/listTopImg/listTopImg';

export default {
  name: 'about',
  components: {TopNavigation, FooterNavigation, listTopImg, aboutPage, suggestions, twoLevelList, mySuggestions, suggestionsList, },
  title () {
    return {
      title: '脂玫乐联系方式|脂玫乐投诉建议-脂玫乐(谷医坊)',
      keywords: '脂玫乐联系方式，脂玫乐投诉建议，健康瘦身',
      description: '脂玫乐投诉、建议与相关问题，请联系脂玫乐官网，您的参与将帮助我们改进产品和服务。',
    };
  },
  data: () => ({
    type: 1,
    navLsit: [
      {
        code: '',
        pid: 0,
        id: 0,
        text: '联系我们',
        type: 'about',
      }, {
        code: '',
        pid: 0,
        id: 0,
        text: '投诉建议',
        type: 'about',
      },
    ],
    phone: '',
  }),
  mounted () {
    if (window.history && window.history.pushState) {
      // 向历史记录中插入了当前页
      history.pushState(null, null, document.URL);
      window.addEventListener('popstate', this.goBack, false);
    }
  },
  beforeDestroy () {
    window.removeEventListener('popstate', this.goBack, false);
  },
  methods: {
    goBack () {
      if (this.type == 3) {
        this.type = 2;
      } else {
        history.back();
      }
    },
    clickType (data) {
      this.type = data + 1;
    },
    suggestionsList (data) {
      this.clickType(data.type);
      this.phone = data.phone;
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// about.vue